if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            // 🔥 INIT CUSTOM VARIANT SELECT (PCI)
const variantSelects = this.modalContent.querySelectorAll('select[data-variant-select]');

variantSelects.forEach((select) => {
  select.addEventListener('change', (e) => {
    const selectedVariantId = e.target.value;

    // Find the form inside the modal
    const form = this.modalContent.querySelector('form');
    if (!form) return;

    // Find hidden input for variant ID
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    // Update variant ID
    variantInput.value = selectedVariantId;

    // 🔄 Trigger change event (important for price updates if hooked)
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        if (!productElement) return;

        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.keepOnlyEssential(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      keepOnlyEssential(productElement) {
        productElement.querySelectorAll('.product-type-note').forEach((el) => el.remove());
        productElement.querySelectorAll('.product__title').forEach((el) => el.remove());
        productElement.querySelectorAll('.share-button').forEach((el) => el.remove());
        productElement.querySelectorAll('.rating-wrapper').forEach((el) => el.remove());
        productElement.querySelectorAll('.product__tax').forEach((el) => el.remove());
        productElement.querySelectorAll('.product__sku').forEach((el) => el.remove());
        productElement.querySelectorAll('.volume-pricing-note').forEach((el) => el.remove());
        productElement.querySelectorAll('[id^="Volume-Note-"]').forEach((el) => el.remove());

        const textBlocks = productElement.querySelectorAll('.product__text, .product__description, .inline-richtext, .rte');
        textBlocks.forEach((el) => {
          const text = (el.textContent || '').trim();
          if (
            text.includes("WHAT'S INCLUDED") ||
            text.includes('WHAT’S INCLUDED') ||
            text.includes('PLEASE NOTE') ||
            text.includes('Personalized favor boxes designed') ||
            text.includes('This is a physical item that will be handmade and shipped to you')
          ) {
            el.remove();
          }
        });

        const infoContainer = productElement.querySelector('.product__info-container');
        if (!infoContainer) return;

        Array.from(infoContainer.children).forEach((child) => {
          const keep =
            // PRICE
            child.matches('[id^="price-"]') ||
            child.querySelector('[id^="price-"]') ||
            child.classList.contains('price') ||
            child.querySelector('.price') ||

            // STANDARD VARIANTS / SET
            child.matches('.product-form__input') ||
            child.querySelector('.product-form__input') ||
            child.querySelector('variant-selects') ||
            child.querySelector('variant-radios') ||
            child.querySelector('select[name*="option"]') ||
            child.querySelector('select[name*="Option"]') ||
            child.querySelector('input[type="radio"]') ||
            child.querySelector('fieldset') ||

            // CUSTOM SET SELECTOR (your setup)
            child.matches('.pci-field') ||
            child.querySelector('.pci-field') ||
            child.matches('.pci-select-wrapper') ||
            child.querySelector('.pci-select-wrapper') ||
            child.querySelector('select.pci-input') ||
            child.querySelector('select[data-variant-select]') ||
            child.querySelector('label.pci-label') ||

            // QUANTITY
            child.matches('.product-form__quantity') ||
            child.querySelector('.product-form__quantity') ||
            child.querySelector('quantity-input') ||
            child.matches('[id^="Quantity-Form-"]') ||
            child.querySelector('[id^="Quantity-Form-"]') ||

            // ADD TO CART / BUY BUTTONS
            child.matches('.product-form') ||
            child.querySelector('.product-form') ||
            child.querySelector('[name="add"]') ||
            child.querySelector('.product-form__buttons') ||

            // PERSONALIZATION / LINE ITEM PROPERTIES
            child.querySelector('[name^="properties["]') ||
            child.querySelector('input[name^="properties["]') ||
            child.querySelector('textarea[name^="properties["]') ||
            child.querySelector('select[name^="properties["]') ||
            child.querySelector('.product-personalizer') ||
            child.querySelector('.line-item-property__field') ||
            child.querySelector('.product-customizer') ||
            child.querySelector('.custom-product-field') ||

            // VIEW FULL DETAILS
            child.matches('.product__view-details') ||
            child.querySelector('.product__view-details');

          if (!keep) {
            child.remove();
          }
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        if (!sectionId) return;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}